/** Hues for initials avatars: no pinks (redesign feedback, 2026-09-11). */
const HUES = [45, 170, 210, 20, 280, 95];

export interface PersonLike {
  id: number;
  name: string;
  photo_url?: string | null;
}

const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .map((w) => w[0])
    .join("")
    .replace(".", "")
    .slice(0, 2)
    .toUpperCase();

export function Avatar({ person }: { person: PersonLike }) {
  return (
    <span className="av" style={{ ["--h" as string]: HUES[person.id % HUES.length] }} title={person.name}>
      {person.photo_url ? <img src={person.photo_url} alt="" loading="lazy" referrerPolicy="no-referrer" /> : initials(person.name)}
    </span>
  );
}
